<app-pos-profile-form-wrapper
  data-testid="pos-profile-edit-form-wrapper"
  [config]="config"
  [editMode]="true"
  [viewMode]="false"
></app-pos-profile-form-wrapper>
